"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.NameField = exports.Buttons = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  marginTop: theme.spacing(3),
  textAlign: 'center'
}));
const Buttons = exports.Buttons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(4)
  }
}));
const NameField = exports.NameField = (0, _mui.styled)(_mui.TextField)({
  boxSizing: 'content-box'
});
//# sourceMappingURL=styles.js.map